import { UserInfo, ILoginRequest, LoginStatus } from '../common/defaults';

export const LOG_OUT = 'SET_LOGGED_IN';
export const SET_LOGGING_IN = 'SET_LOGGING_IN';
export const SET_ERROR_LOGGING_IN = 'SET_ERROR_LOGGING_IN';
export const SET_USER = 'SET_USER';

export const setLoggingIn = (loggingIn: boolean) => {
  return {
    type: SET_LOGGING_IN,
    value: loggingIn
  };
};

export const errorLoggingIn = (error: string) => {
  return {
    type: SET_ERROR_LOGGING_IN,
    value: error
  };
};

export const logOut = () => {
  return {
    type: LOG_OUT
  };
};

export const setUserInfo = (user?: UserInfo) => {
  return {
    type: SET_USER,
    value: user
  };
};

export const remoteLogin = (
  loginRequest: ILoginRequest,
  requestURL: string
) => {
  return async dispatch => {
    await dispatch(setLoggingIn(true));
    try {
      const headers = new Headers([
        ['Accept', 'application/json, text/plain, */*'],
        ['Content-Type', 'application/json']
      ]);

      const response: any = await fetch(requestURL, {
        method: 'POST',
        headers,
        body: loginRequest && JSON.stringify(loginRequest)
      });

      if (response.ok) {
        response.json().then(async json => {
          await dispatch(setLoggingIn(false));
          if (json.status == LoginStatus.Success) {
            let user = json.loggedInUser;
            user.token = json.token;
            dispatch(setUserInfo(user));
          }
        });
      } else {
        console.log('There was an error with the response!');
      }
    } catch (ex) {
      console.log(ex);
    }
  };
};
